import {saveDrawItDataInCache, getDrawItDataInCache} from 'helpers/cache/cacheManager'

function saveDrawItQuestionData(submitData, session, slideIndex, answers) {
	saveDrawItDataInCache(
		answers,
		session.presentation_uid,
		session.session_uid + '_' + slideIndex,
		session.pincode,
	)
}

async function getDrawItAnswersData(questionData, session, slide) {

	const answersFromCache = await getDrawItDataInCache(
		session.presentation_uid,
		session.session_uid + '_' + slide.slideId,
		session.pincode
	)

	return answersFromCache
}

export {
	saveDrawItQuestionData,
	getDrawItAnswersData,
}
